import script from "./CourseViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseViewer.vue?vue&type=script&setup=true&lang=js"

import "./CourseViewer.vue?vue&type=style&index=0&id=18a75376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18a75376"]])

export default __exports__